import { createStore } from "vuex";
import chat from "./app/chat";
import email from "./app/email";
import kanban from "./app/kanban";
import project from "./app/project";
import apptodo from "./app/todo";
import downloads from "./app/downloads";
export default createStore({
  state: {
    sidebarCollasp: false,
    sidebarHidden: false,
    mobileSidebar: true,
    semidark: false,
    semiDarkTheme: "semi-light",
    isDark: false,
    skin: "default",
    theme: "light",
    isOpenSettings: false,
    cWidth: "full",
    menuLayout: "vertical",
    navbarType: "sticky",
    // footerType: "static",
    footerType: "hidden",
    chartColors: {
      title: "red",
    },
    currentUser: {},
    // Brouillon de génération IA transféré depuis l'accueil vers la page Personnalisation.
    // image = image générée (data URL), prompt = texte saisi, type = type de média cible.
    aiDraft: {
      image: "",
      prompt: "",
      type: "",
    },
    // URL de l'image générée transférée depuis la page IA vers la modal Thème IA
    // (page Personnalisation) pour être utilisée comme vignette du thème.
    themeIaDraftImage: "",
    // Média du catalogue (fond/habillage/écran/email) transféré depuis « Mon
    // catalogue » vers le Studio : url = image S3, type = type de média cible.
    // fillSurfaces = remplir toutes les surfaces branding (envoi IA depuis l'accueil).
    studioDraft: {
      url: "",
      type: "",
      fillSurfaces: false,
    },
    token_expires_in: null, // temps en minutes avant expiration du token
    token_refresh_expires_in: null, // temps en minutes avant obligation de signin de nouveau
    loginTime: null, // timestamp du moment du login (pour token_refresh_expires_in)
    tokenRefreshTime: null, // timestamp du dernier refresh de token (pour token_expires_in)
  },
  getters: {
    theme: (state) => state.theme,
    skin: (state) => state.skin,
    currentUser: (state) => state.currentUser,
    tokenExpiresIn: (state) => state.token_expires_in,
    tokenRefreshExpiresIn: (state) => state.token_refresh_expires_in,
    loginTime: (state) => state.loginTime,
  },
  mutations: {
    setSidebarCollasp(state) {
      state.sidebarCollasp = !state.sidebarCollasp;
    },

    toogleDark(state) {
      // Retirer l'ancienne classe
      document.body.classList.remove(state.theme);
      
      // Inverser les états
      state.isDark = !state.isDark;
      state.theme = state.theme === "dark" ? "light" : "dark";
      
      // Ajouter la nouvelle classe
      document.body.classList.add(state.theme);
      localStorage.setItem("theme", state.theme);
    },

    toggleSettings(state) {
      state.isOpenSettings = !state.isOpenSettings;
    },
    toggleMsidebar(state) {
      state.mobileSidebar = !state.mobileSidebar;
    },
    toggleSemiDark(state) {
      state.semidark = !state.semidark;
      state.semiDarkTheme = state.semidark ? "semi-dark" : "semi-light";
      document.body.classList.toggle(state.semiDarkTheme);
      localStorage.setItem("semiDark", state.semidark);
    },
    toggleMenuLayout(state) {
      state.menuLayout = state.menuLayout === "vertical" ? "horizontal" : "vertical";
      localStorage.setItem("menuLayout", state.menuLayout);
    },
    setCurrentUser(state, data) {
      state.currentUser = data;
      localStorage.setItem("currentUser", JSON.stringify(data));
    },
    setAiDraft(state, data) {
      state.aiDraft = {
        image: data.image || "",
        prompt: data.prompt || "",
        type: data.type || "",
      };
    },
    clearAiDraft(state) {
      state.aiDraft = { image: "", prompt: "", type: "" };
    },
    setThemeIaDraftImage(state, url) {
      state.themeIaDraftImage = url || "";
    },
    clearThemeIaDraftImage(state) {
      state.themeIaDraftImage = "";
    },
    setStudioDraft(state, data) {
      state.studioDraft = {
        url: (data && data.url) || "",
        type: (data && data.type) || "",
        fillSurfaces: !!(data && data.fillSurfaces),
      };
    },
    clearStudioDraft(state) {
      state.studioDraft = { url: "", type: "", fillSurfaces: false };
    },
    setRememberLoginFormateur(state, data) {
      localStorage.setItem("rememberLoginFormateur", data.login);
      localStorage.setItem("rememberPassFormateur", data.password);
    },
    setRememberLoginUtilisateur(state, data) {
      localStorage.setItem("rememberLoginUtilisateur", data.login);
      localStorage.setItem("rememberPassUtilisateur", data.password);
    },
    setTokenInfo(state, data) {
      if (data.token_expires_in !== undefined) {
        state.token_expires_in = data.token_expires_in;
        localStorage.setItem("token_expires_in", data.token_expires_in);
      }
      if (data.token_refresh_expires_in !== undefined) {
        state.token_refresh_expires_in = data.token_refresh_expires_in;
        localStorage.setItem("token_refresh_expires_in", data.token_refresh_expires_in);
      }
      
      // Réinitialiser loginTime (connexion initiale ou reconnexion complète)
      if (data.resetLoginTime !== false) {
        state.loginTime = Date.now();
        localStorage.setItem("loginTime", state.loginTime);
      }
      
      // Toujours mettre à jour tokenRefreshTime quand on met à jour token_expires_in
      if (data.token_expires_in !== undefined) {
        state.tokenRefreshTime = Date.now();
        localStorage.setItem("tokenRefreshTime", state.tokenRefreshTime);
      }
    },
  },
  actions: {
    // toogleDark
    toogleDark({ commit }) {
      commit("toogleDark");
    },
    // toggleSettings
    toggleSettings({ commit }) {
      commit("toggleSettings");
    },
    // setSidebarCollasp
    setSidebarCollasp({ commit }) {
      commit("setSidebarCollasp");
    },
    // toggleMsidebar
    toggleMsidebar({ commit }) {
      commit("toggleMsidebar");
    },
    toggleSemiDark({ commit }) {
      commit("toggleSemiDark");
    },
    toggleMenuLayout({ commit }) {
      commit("toggleMenuLayout");
    },
    setCurrentUser({ commit }, data) {
      commit("setCurrentUser", data);
    },
    setRememberLoginFormateur({ commit }, data) {
      commit("setRememberLoginFormateur", data);
    },
    setRememberLoginUtilisateur({ commit }, data) {
      commit("setRememberLoginUtilisateur", data);
    },
    setTokenInfo({ commit }, data) {
      commit("setTokenInfo", data);
    },
    // setTheme
  },
  modules: {
    apptodo,
    project,
    kanban,
    email,
    chat,
    downloads,
  },
});
